import { Box, Stack } from "@mui/joy";
import { useRecoilValue } from "recoil";
import CoachingContent from "./CoachingContent";
import TaskHeader from "components/task/header/TaskHeader";
import { userAtom } from "recoil/userAtom";
import ChatPatientContent from "./ChatPatientContent";

export default function Chat() {
  const user = useRecoilValue(userAtom);
  const isPatient = user?.role === "patient";

  return (
    <>
      <Box
        sx={{
          flex: "none",
          zIndex: 100,
        }}
      >
        {!isPatient && <TaskHeader taskKey={"chat"} />}
      </Box>

      <Stack
        sx={{
          flex: 1,
          overflow: "hidden",
        }}
      >
        {isPatient ? <ChatPatientContent /> : <CoachingContent />}
      </Stack>
    </>
  );
}